<template>
    <v-row :value="value" no-gutters>
        <v-skeleton-loader
            v-if="loading"
            class="pa-0"
            type="list-item-avatar@6"
            style="width: 100%;"
        ></v-skeleton-loader>
        <v-col cols="12" class="subtitle-1 text--primary py-0 mt-0 mb-0" v-else>
            <v-row no-gutters align="center">
                <v-col >
                    
                </v-col>
                <v-col cols="auto" class="pr-1 mb-n8" >
                    <v-checkbox
                        v-model="selectAll"
                        color="secondary"
                        class="pt-0 mt-0 mb-0"
                        hide-details
                    >
                        <template v-slot:label>
                            <h4
                                class="subtitle-2"
                                v-text="translations.selectAll[lang]"
                            ></h4>
                        </template>
                    </v-checkbox>
                </v-col>
            </v-row>
        </v-col>
        <v-treeview
            v-if="renderComponent && !loading"
            v-model="tree.selected"
            :items="tree.treeview"
            selectable
            transition
            dense
            :loading="loading"
            item-key="path"
            selected-color="secondary"
        ></v-treeview>
    </v-row>
</template>

<script>
import Treeview from "@/models/Treeview";
import translations from "@/utils/translations/global";

export default {
    name: "BObjectTreeview",

    props: {
        value: {
            type: Object
        }, 
        transformedNames: {
            type: Boolean,
            default: true
        },
        loading: Boolean
    },

    mixins: [translations],

    data() {
        return {
            renderComponent: true,
            selectAll: false,
            tree: [],
            allChildren: []
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        }
    },

    methods: {
        async forceRerender() {
            this.renderComponent = false;
            await this.$nextTick();
            this.renderComponent = true;
        },
        elementAction(val) {
            this.forceRerender();
        },

        updatePayload() {
            this.allChildren.forEach(child => {
                if (child.path !== undefined) {
                    this.tree.updatePayloadValue(child.path, false);
                }
            });
            this.tree.selected.forEach(item => {
                if (item !== undefined) {
                    this.tree.updatePayloadValue(item, true);
                }
            });
        }
    },

    watch: {
        ["tree.treeview"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    val.forEach(item => {
                        this.allChildren = [
                            ...this.allChildren,
                            ...this.tree.getChildren(item)
                        ];
                    });
                }
            },
            deep: true
        },

        selectAll(val) {
            if (!val) {
                return (this.tree.selected = []);
            }

            this.allChildren.forEach(child => {
                this.tree.selected = [...this.tree.selected, child.path];
            });
        },

        value: {
            immediate: true,
            handler(val) {
                if (val) {
                    if (!this.tree?.payload != val) {
                        this.tree = new Treeview(val, this.transformedNames);
                    }
                    this.tree.payload = val;
                }
            }
        },

        ["tree.selected"]: {
            immediate: true,
            handler(val) {
                // this.elementAction();
                this.$nextTick(() => {
                    this.updatePayload();
                });
            }
        }
    }
};
</script>
